import axiosInstance from '../../api/axiosInstance';

export const getService = async (payload) => {
    const response = await axiosInstance.get(`/wealth/portfolio-stock-list?userId=${payload}`,);
    return response.data;
};

export const getMultibaggerListService = async () => {
    const response = await axiosInstance.get(`/wealth/get-multibaggers`);
    return response.data;
};

export const addPortfolio = async (payload) => {
    const response = await axiosInstance.post(`/wealth/add-to-portfolio`, payload);
    return response.data;
};

export const updatePortfolio = async (payload) => {
    const response = await axiosInstance.post(`/wealth/update-to-portfolio`, payload);
    return response.data;
};